import { render, staticRenderFns } from "./DropdownDivider.vue?vue&type=template&id=18173f86&scoped=true&functional=true&"
import script from "./DropdownDivider.vue?vue&type=script&lang=ts&"
export * from "./DropdownDivider.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownDivider.vue?vue&type=style&index=0&id=18173f86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "18173f86",
  null
  
)

export default component.exports